import { API } from '../../../../../api'
import { PageList } from '../../../utils'

import { QUERY } from './queries'

const List: PageList<API.course_chapters_index> = {
  queryKey: 'courseChapters',
  query: QUERY,
}

export default List
